export default __webpack_public_path__ + "static/media/unchecked-box.5b6fb95d.svg";